import { Action, Reducer } from 'redux';
import {
  RateImportStatusActionTypes,
  RateImportStatusState,
  RateImportStatusTypes
} from './rateImportStatusTypes';

export const INITIAL_STATE: RateImportStatusState = {
  rateImportStatus: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const rateImportStatusReducer: Reducer<RateImportStatusState> = (
  state: RateImportStatusState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as RateImportStatusActionTypes;
  switch (actionTypes.type) {
    case RateImportStatusTypes.GET_RATE_IMPORT_STATUS:
      return {
        ...state,
        rateImportStatus: { ...state.rateImportStatus, isLoading: true }
      };
    case RateImportStatusTypes.SAVE_RATE_IMPORT_STATUS:
      return {
        ...state,
        rateImportStatus: {
          ...state.rateImportStatus,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case RateImportStatusTypes.RESET_REDUCER_RATE_IMPORT_STATUS:
      return {
        ...state,
        rateImportStatus: INITIAL_STATE.rateImportStatus
      };
    default:
      return state;
  }
};

export default rateImportStatusReducer;
